import { useBuilderStore } from "./useBuilderStore";

/**
 * Hook to check if the current BuilderUI instance is running in iframe preview mode
 * @returns boolean indicating if this is an iframe preview
 */
export const useIsIframePreview = (): boolean =>
  useBuilderStore(state => state.isIframePreview);
